import { Box, Stack, Typography } from '@mui/material';

import { Pagination } from '@occc/ui-design-system';
import { KioskFragment } from '@occc/graphql';
import { IPaginationProps } from '@occc-app/hooks/usePaginatedQuery';
import { formatFullAddress } from '@occc/utils-formatters';

type TargetedKiosksListProps = {
  kiosks: KioskFragment[];
  paginationProps: IPaginationProps;
};

export const TargetedKiosksList = ({ kiosks, paginationProps }: TargetedKiosksListProps) => {
  return (
    <Stack spacing={1}>
      {kiosks.map((kiosk) => {
        const kioskId = kiosk?.id || '';
        const address = formatFullAddress(kiosk.location?.address);

        return (
          <Box
            key={kiosk.id}
            sx={(theme) => ({
              display: 'flex',
              py: theme.spacing(0.5),
            })}
          >
            <Typography variant='body2' sx={{ flex: 1 }}>
              {kioskId}
            </Typography>
            <Typography variant='body2' sx={{ flex: 1 }}>
              {address || '-'}
            </Typography>
          </Box>
        );
      })}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
        <Pagination {...paginationProps} />
      </Box>
    </Stack>
  );
};
